import React, { useEffect, useState, useRef } from "react";
import { injectModels } from "../redux/injectModels";
import { routes } from "../constants/routes";
import { Link } from "react-router-dom";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AuthService } from "../services";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../redux/Models/Application/constants";
import HeaderLogo from "../components/Logo/HeaderLogo";
//import Modal from "react-bootstrap/Modal";
//import { Button } from "react-bootstrap";
import { ModelPopup } from "../components/Common/ModelPopup";
import { globalConstant } from "../constants/globalConstant";
import { handleConsoleError } from "../utils/common-methods";
import ReCAPTCHA from "react-google-recaptcha";
import { VerifyCaptcha } from "../services/InquiryService";
import { GlobalSettingService } from "../services";

// const USER = {
//   "Event Organiser": 0,
//   "Trader & Retailer": 1,
//   "Customers/Ticket Buyers": 2,
//   "Mobile Caterers": 3,
// };

function SignUp(props) {
  const location = useLocation();
  const recaptchaRef = useRef(null);
  const params = new URLSearchParams(location.search);
  const urlRole = params.get("role");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState("");
  const [roleId, setRoleId] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstnameError, setFirstNameError] = useState("");
  const [lastnameError, setLastNameError] = useState("");
  const [passError, setPassError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [termError, setTermError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [termsShow, setTermsShow] = useState(false);
  const [isTermsAccepted, setTermAccepted] = useState(false);

  const [error, setError] = useState("");
  const [token, setToken] = useState(null);
  const [captchaError, setCaptchaError] = useState("");
  const [captchaKey, setCaptchaKey] = useState("");

  const getCaptchaDetails = async () => {
    try {
      const res = await GlobalSettingService.getRecaptchaDetails();
      if (res?.isSuccess && res?.data) {
        setCaptchaKey(GlobalSettingService.decrypt(res?.data?.keyValue));
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  // useEffect(() => {
  //   const bootstrapAsync = async () => {
  //     await Promise.all([props.application?.getRoles(), getCaptchaDetails()]);
  //     if (props.application?.activeRole) {
  //       setCurrentUser(props.application?.activeRole?.roleName??'');
  //       setRoleId(props.application?.activeRole?.id??'');
  //     } else {
  //       if (props.application?.roles && props.application?.roles?.length > 0) {
  //         if (urlRole && urlRole > 0) {
  //           //TODO
  //           let activeRole = (props.application?.roles ?? []).filter(
  //             (role) => role.id === +urlRole,
  //           );
  //           if (activeRole.length > 0) {
  //             dispatch({
  //               type: CONSTANTS.SET_ACTIVE_ROLE,
  //               payload: activeRole[0],
  //             });
  //           }
  //           setCurrentUser(activeRole?.roleName??'');
  //           setRoleId(activeRole?.id??'');
  //         } else {
  //           setCurrentUser(props.application?.roles[0]?.roleName??'');
  //           setRoleId(props.application?.roles[0]?.id??'');
  //         }
  //       }
  //     }
  //   };
  //   bootstrapAsync();
  // }, [currentUser]);
  // 1. Fetch roles & captcha on initial component mount only
  useEffect(() => {
    props.application?.getRoles?.();
    getCaptchaDetails();
  }, []);

  // 2. React to roles when they arrive in props
  useEffect(() => {
    const roles = props.application?.roles;
    if (!roles || roles.length === 0) return;

    // Case A: urlRole is present in query params
    if (urlRole) {
      const matched = roles.find((r) => String(r.id) === String(urlRole));
      if (matched) {
        dispatch({
          type: CONSTANTS.SET_ACTIVE_ROLE,
          payload: matched,
        });
        setCurrentUser(matched.roleName ?? "");
        setRoleId(matched.id ?? "");
        return;
      }
    }

    // Case B: An activeRole was already set in the store
    if (props.application?.activeRole) {
      setCurrentUser(props.application.activeRole.roleName ?? "");
      setRoleId(props.application.activeRole.id ?? "");
      return;
    }

    // Case C: Default to the first role in the list
    const defaultRole = roles[0];
    if (defaultRole) {
      dispatch({
        type: CONSTANTS.SET_ACTIVE_ROLE,
        payload: defaultRole,
      });
      setCurrentUser(defaultRole.roleName ?? "");
      setRoleId(defaultRole.id ?? "");
    }
  }, [props.application?.roles, props.application?.activeRole, urlRole]);

  const handleFirstNameChange = (e) => {
    e.preventDefault();
    //value.charAt(0).toUpperCase() + value.slice(1)
    const val =
      e.target.value
        .charAt(0)
        .toUpperCase()
        .trim() + e.target?.value?.slice(1)?.trim();
    if (val === "") {
      setFirstNameError("First name is required");
    } else {
      setFirstNameError("");
    }

    setFirstName(val);
  };

  const handleLastNameChange = (e) => {
    e.preventDefault();
    const val =
      e.target.value
        .charAt(0)
        .toUpperCase()
        .trim() + e.target?.value?.slice(1)?.trim();
    if (val === "") {
      setLastNameError("Last name is required");
    } else {
      setLastNameError("");
    }

    setLastName(val);
  };

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target?.value?.trim();
    if (val === "") {
      setEmailError("Email is required");
    } else if (!globalConstant.emailRegex.test(val)) {
      setEmailError("Please enter a valid email");
    } else {
      setEmailError("");
    }

    setEmail(val);
  };

  const handlePasswordChange = (e) => {
    // e.preventDefault();
    const val = e.target?.value;
    if (val.trim() === "") {
      setPassError("Password is required");
    } else if (!globalConstant.passwordRegex.test(val)) {
      setPassError(
        "Password must contain at least one uppercase letter, one lowercase letter, one number, one symbol and minimum length is 8!.Allowed symbol are @$!%*?&-",
      );
    } else {
      setPassError("");
    }
    setPassword(val);
  };

  const handleChange = (e) => {
    setCurrentUser(e.target?.value);
    let activeRole = (props.application?.roles ?? []).filter(
      (role) => role.roleName === e.target.value,
    );
    if (activeRole.length > 0) {
      setRoleId(activeRole[0].id ?? "");
      dispatch({
        type: CONSTANTS.SET_ACTIVE_ROLE,
        payload: activeRole[0],
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!token) {
        setCaptchaError("Captcha is required.");
        return;
      }
      setCaptchaError("");
      props.application.setLoading(true);

      await VerifyCaptcha({
        captchaToken: token,
      });

      props.application.setLoading(true, "Login!");

      let valid = true;
      if (firstname === "") {
        setFirstNameError("first name is required");
        valid = false;
      } else {
        setFirstNameError("");
      }
      if (lastname === "") {
        setLastNameError("last name is required");
        valid = false;
      } else {
        setLastNameError("");
      }
      if (password.trim() === "") {
        setPassError("Password is required");
        valid = false;
      } else if (!globalConstant.passwordRegex.test(password)) {
        setPassError(
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one symbol and minimum length is 8!",
        );
        valid = false;
      } else {
        setPassError("");
      }

      // if (password === "") {
      //   setPassError("Password is required");
      //   valid = false;
      // } else {
      //   setPassError("");
      // }

      if (email.trim() === "") {
        setEmailError("Email is required");
        valid = false;
        //} else if (!emailRegex.test(email)) {
        //setEmailError("Please enter a valid email address.");
        //valid = false;
      } else {
        setEmailError("");
      }

      if (!valid) {
        props.application.setLoading(false, "");
        return;
      } else {
        if (!isTermsAccepted) {
          setTermError("Please accept terms & conditions.");
          props.application.setLoading(false, "");
          return;
        }

        console.log("roleId :: ", roleId);
        const data = {
          firstName: firstname?.trim(),
          lastName: lastname?.trim(),
          email: email?.trim(),
          password: password,
          userType: roleId ?? props.application?.roles?.[0]?.id,
        };

        props.application.setLoading(true);
        const response = await AuthService.SignUp(data);
        if (response?.isSuccess) {
          props.application.setLoading(false);

          toast.success("User registered successfully. Please check email.");
          dispatch({
            type: CONSTANTS.SET_CURRENT_MODAL,
            payload: CONSTANTS.CLEAR_MODAL,
          });
          navigate(routes.DEFAULT);
          setError("");
        } else {
          props.application.setLoading(false);

          setError(response?.message || "An error occurred");
          toast.error(response?.message || "An error occurred");
          recaptchaRef.current?.reset();
          setToken(null);
          return;
        }
      }
    } catch (err) {
      props.application.setLoading(false);
      const message = handleConsoleError(err);
      setError(err?.message || message);
      toast.error(err?.message || message);
      recaptchaRef.current?.reset();
      setToken(null);
    }
  };

  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const toggleLogin = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.LOGIN_MODAL,
    });
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        <div className="form-container" id="form-container">
          <form id="login-form">
            <HeaderLogo></HeaderLogo>
            <h3>Register</h3>
            <div className="first-name">
              <div className="first-name1">
                <label htmlFor="username">First Name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  id="login-username"
                  value={firstname}
                  required=""
                  autoFocus=""
                  onChange={handleFirstNameChange}
                />

                {firstnameError && (
                  <p className="text-danger">{firstnameError}</p>
                )}
              </div>
              <div className="first-name2">
                <label htmlFor="username">Last Name</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  id="login-username"
                  value={lastname}
                  required=""
                  autoFocus=""
                  onChange={handleLastNameChange}
                />
                {lastnameError && (
                  <p className="text-danger">{lastnameError}</p>
                )}
              </div>
            </div>
            <label htmlFor="username">Email Address</label>
            <input
              type="text"
              placeholder="Email Address"
              id="login-username"
              value={email}
              required=""
              autoFocus=""
              onChange={handleEmailChange}
            />
            {emailError && <p className="text-danger">{emailError}</p>}

            <label htmlFor="username">Select Your Role</label>
            <div className="password-container">
              <select
                name="country"
                id=""
                className="form-control"
                value={currentUser}
                onChange={handleChange}
              >
                {(props.application?.roles ?? []).map((role, index) => (
                  <option key={index} value={role?.roleName}>
                    {role?.roleName}
                  </option>
                ))}
              </select>
              <i
                style={{ color: "#e619d1" }}
                className="fa-solid fa-angle-down"
                id="login-eye"
              ></i>
            </div>
            <label htmlFor="password">Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                id="login-password"
                value={password}
                required=""
                autoFocus=""
                onChange={handlePasswordChange}
              />
              {showPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              )}
            </div>
            {passError && <p className="text-danger">{passError}</p>}
            <div className="password-container">
              {captchaKey && (
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={captchaKey}
                  onChange={(value) => setToken(value)}
                />
              )}
            </div>
            {captchaError && (
              <span style={{ color: "red" }}>{captchaError}</span>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                columnGap: 10,
              }}
            >
              <input
                style={{ width: 18, height: 18, accentColor: "#ed307c" }}
                type="checkbox"
                id="terms"
                value="true"
                onChange={(e) => {
                  setTermAccepted(e.target.checked);
                  if (e.target.checked) {
                    setTermError("");
                  }
                }}
              />
              <p className="signup-text">
                By signing up you agree to our{" "}
                <a
                  href="#!"
                  onClick={() => {
                    setTermsShow(true);
                  }}
                >
                  Terms & Conditions
                </a>
              </p>
            </div>
            {termError && <p className="text-danger">{termError}</p>}
            <button type="submit" onClick={handleSubmit}>
              Register
            </button>

            <p className="signup-text">
              Already have an account ?{" "}
              <a href="#!" onClick={() => toggleLogin()}>
                login
              </a>
            </p>
          </form>
        </div>
      </section>
      <ModelPopup
        title="Terms & Conditions"
        isHtml
        description={globalConstant?.termsHtmlText}
        show={termsShow}
        onClose={() => {
          setTermsShow(false);
        }}
      ></ModelPopup>
    </React.Fragment>
  );
}
export default injectModels(["application"])(SignUp);
